// A date column's FILTERS value in the tenant's date format (BP-83), for
// AeronetDataGrid's server-mode filters.
//
//   { field: "flightdate", type: "date", filterOperators: tenantDateFilterOperators() }
//
// MUI's own date input is a native <input type="date"> — the BROWSER's locale
// (mm/dd/yyyy on a US machine), whatever the tenant is set to — and in v6 it
// stores a Date, which the grid then JSON-serialises as a UTC timestamp: local
// midnight on the 3rd reaches the server as "…-02T11:00:00.000Z" east of
// Greenwich. This input is TenantDatePicker, and the item's value is the
// wire's own "YYYY-MM-DD" string, so the server gets the day the user picked
// and a saved filter (filterApi.ts, JSON) restores to the same day.
//
// The operators are MUI's date set MINUS isEmpty / isNotEmpty: those carry no
// value, and DataGrid.tsx drops a valueless item before the request — a
// filter offered and never sent.
import React from "react";
import {
  getGridDateOperators,
  GridFilterInputValueProps,
  GridFilterOperator,
} from "@mui/x-data-grid-pro";

import TenantDatePicker from "../TenantDatePicker";

export function TenantDateFilterInput({ item, applyValue }: GridFilterInputValueProps) {
  return (
    <TenantDatePicker
      label="Value"
      size="small"
      value={typeof item.value === "string" ? item.value : ""}
      onChange={(iso) => applyValue({ ...item, value: iso || undefined })}
      textFieldProps={{ variant: "standard" }}
    />
  );
}

/** The operators every one of which reaches the request with a value. */
export const TENANT_DATE_FILTER_OPS = ["is", "not", "after", "onOrAfter", "before", "onOrBefore"];

export function tenantDateFilterOperators(): GridFilterOperator[] {
  return getGridDateOperators()
    .filter((op) => TENANT_DATE_FILTER_OPS.includes(op.value))
    .map((op) => ({ ...op, InputComponent: TenantDateFilterInput }));
}
